<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M4.98901 6C4.98901 5.17157 5.66059 4.5 6.48901 4.5H17.489C18.3174 4.5 18.989 5.17157 18.989 6V7.84986C18.989 8.26408 18.6532 8.59986 18.239 8.59986C17.8248 8.59986 17.489 8.26408 17.489 7.84986V6.50086C17.489 6.22438 17.2646 6.00039 16.9881 6.00087L12.7472 6.00819L12.7582 18C12.7582 18.5523 13.2059 19 13.7582 19H15.165C15.5792 19 15.915 19.3358 15.915 19.75C15.915 20.1642 15.5792 20.5 15.165 20.5H8.85141C8.4372 20.5 8.10141 20.1642 8.10141 19.75C8.10141 19.3358 8.4372 19 8.85141 19H10.2582C10.8105 19 11.2582 18.5523 11.2582 18L11.2472 6.00819L6.98987 6.00086C6.7134 6.00039 6.48901 6.22438 6.48901 6.50086V7.87752C6.48901 8.29174 6.15323 8.62752 5.73901 8.62752C5.3248 8.62752 4.98901 8.29174 4.98901 7.87752V6Z"
      fill="#0B1922"
      fill-opacity="0.75"
    />
  </svg>
</template>

<script setup lang="ts"></script>
